import CONFIRM_DIALOGS from './confirm-dialog/fr';
import ERROR_DIALOGS from "./error-dialog/fr";
import RESULT_DIALOGS from "./result-dialog/fr";

export default {
    BUTTONS: {
        SUBMIT: "Soumettre",
        PREVIOUS: "Précédent",
        NEXT: "Prochain",
        VIEW: "Voir",
        UPLOAD: "Télécharger",
        CLOSE: "Fermé",
        DELETE: "Effacer",
        CANCEL: "Annuler",
        YES: "Oui",
        NO: "Non",
        OK: "D'accord",
        ADD: "Add",
        UPDATE_STATUS: "État de la mise à jour",
        RETURN_DASHBOARD: "Revenir au tableau de bord",
        REFRESH: "Actualiser",
        BULK_UPDATE_STATUS: "Mettre à jour l'état de la sélection",
        BULK_UPDATE: "Mise à jour groupée",
        BULK_DELETE: "Supprimer la sélection",
        BULK_UNASSIGNED: "Désattribuer la sélection",
        EXPORT_EMPLOYERS: "Exporter la liste de diffusion des clients",
        UPDATE_MANAGER: "Gestionnaire de mise à jour",
        VIEW_PROFILE: "Afficher le profil",
        VIEW_OFFER: "Afficher l'offre",
        SAVE: "Enregistrer",
        EXPAND_ALL: "Tout développer",
        COLLAPSE_ALL: "Tout réduire",
        RESET_FILTERS: "Réinitialiser les filtres",
        CLOCK_IN: "Horloge d'arrivée",
        CLOCK_OUT: "Horloge terminée",
        LEAVE_REVIEW: "Laisser un avis",
        DECLINE: "Refuser",
        ACCEPT: "Accepter",
        CHECK_PAYMENT: "Paiement par chèque"
    },
    PLACE_HOLDERS: {
        NEW_STATUS: "Nouveau statut",
        FILTER_BY_STATUS: "Filtrer par statut",
        FILTER_BY_STATUSES: "Filtrer par statuts",
        STATUSES_TO_HIDE: "Statuts à masquer",
        FILTER_BY_LOCATIONS: "Filtrer par emplacements",
        FILTER_BY_TYPES: "Filtrer par types",
        FILTER_BY_MANAGER: "Filtrer par responsable",
        FILTER_BY_CATEGORIES: "Filtrer par catégories",
        FILTER_BY_START_DATE: "Filtrer par date de début",
        FILTER_BY_END_DATE: "Filtrer par date de fin",
        FILTER_BY_CLIENTS: "Filtrer par clients",
        FILTER_BY_CLIENT_STATUSES: "Filtrer par statuts de client",
        FILTER_BY_CLIENT_TYPES: "Filtrer par types de clients",
        FILTER_BY_CANDIDATES: "Filtrer par candidat(s)",
        FILTER_BY_JOB_TYPES: "Filtrer par type de travail",
        FILTER_BY_JOB_STATUSES: "Filtrer par statuts de travail",
        FILTER_BY_USER_TYPE: "Filtrer par type d'utilisateur",
        KEYWORD_SEARCH_USER_PROFILE: "Recherchez un mot-clé/une phrase n'importe où sur le profil de l'utilisateur, appuyez sur Entrée pour appliquer la recherche",
        SEARCH_BY_NAME_EMAIL_PHONE: "Recherche par nom, e-mail ou numéro de téléphone",
        FILTER_BY_RECENT_ACTIVE: "Filtrer par activité récente",
        SELECT_LOCATIONS: "Sélectionner des emplacements",
        SELECT_OPTION: "Sélectionner une option",
        SELECT_CLIENT: "Sélectionner un client",
        SELECT_CANDIDATE: "Sélectionner un candidat",
        SELECT_CANDIDATES: "Sélectionner des candidats",
        SELECT_CANDIDATE_SEARCHABLE: "Sélectionner le candidat (saisir pour rechercher)",
        SELECT_ADMINS: "Sélectionner les administrateurs",
        SELECT_ADMIN_RECEIVE_EMAIL: "Sélectionner les administrateurs qui reçoivent des e-mails",
        SELECT_STATUS: "Sélectionner le statut",
        SELECT_LANGUAGES: "Sélectionner les langues",
        SELECT_TYPES: "Sélectionner les types",
        SELECT_TYPE: "Sélectionner le type",
        SELECT_USER_TYPE: "Sélectionner le type d'utilisateur",
        SELECT_USER_TYPES: "Sélectionner les types d'utilisateurs",
        SELECT_CATEGORY: "Sélectionner une catégorie",
        SELECT_CATEGORY_ADMIN_ONLY: "Sélectionner une catégorie (administrateur uniquement)",
        SELECT_TRIGGER: "Sélectionner le déclencheur",
        SELECT_ONE: "Sélectionnez-en un",
        SELECT_PROFILE_BUILDER: "Sélectionner le créateur de profil",
        SELECT_TIME_OFF_CATEOGRY: "Sélectionner la catégorie de temps libre",
        SELECT_DESTINATION: "Sélectionner la destination",
        SELECT_ACCESS_LEVEL: "Sélectionner le niveau d'accès",
        SELECT_VISIBILITY_SCOPE: "Sélectionner l'étendue de la visibilité",
        SELECT_AREAS: "Sélectionner des zones",
        NUMBER: "Numéro",
        DESCRIPTION_CHARGE: "Description des frais",
    },
    LABELS: {
        SELECT_TEMPLATE: "Sélectionner un modèle",
        FILTER_BY_LOCATIONS: "Filtrer par emplacements",
        FILTER_BY_TYPES: "Filtrer par types",
        FILTER_BY_MANAGER: "Filtrer par gestionnaire",
        FILTER_BY_CATEGORIES: "Filtrer par catégories",
        FILTER_BY_STATUS: "Filtrer par statut",
        ADDRESS: "Adresse",
        CITY: "Ville",
        STATE: "État",
        COUNTRY: "Pays",
        ZIP_CODE: "Code postal",
        LOCATIONS: "Lieux",
        DESCRIPTION: "Description",
        ADD_ITEM: "Ajouter {0}",
        EDIT_ITEM: "Éditer {0}",
        SAVE_AND_ADD_ANOTHER_ITEM: "Sauvegarder et ajouter un autre {0}",
        WELCOME_TEXT: "Bienvenue sur {0}"
    },
    HEADERS: {
        EMAIL_LOG: "Journal des e-mails",
        SMS_LOG: "Journal SMS"
    },
    LINK_TEXT: {
        HIDE_STATUS_BY_DEFAULT: "Comment masquer les statuts par défaut",
        HOW_TO_CHANGE_STATUS: "Comment ajouter/modifier des statuts"
    },
    DESCRIPTIONS: {
        SEPARATE_MULTIPLE_EMAIL: "Séparez plusieurs e-mails avec ; (par exemple : nanny1@hotmail.com ; nanny2@hotmail.com )",
        SMS_NOTE: `Veuillez noter qu'il y a un coût de 0,0115 $ (1,15 ¢) par SMS. S'il te plaît
         notez également qu'il est actuellement impossible de répondre aux SMS.`,
        CLIENT_NOT_ENTERED_STRIPE: "Le client n'a pas saisi les informations Stripe.",
        INTERVIEW_PANEL: `Remarque : ces notes sont destinées à l'administrateur interne uniquement et ne sont pas
         partagé avec les candidats ou les clients.`,
        CANDIDATE_SHAREABLE_LINK: `Ceci est un lien partageable du profil du candidat. Si tu veux
         pour voir ce qu'un client verra, assurez-vous de vous déconnecter, puis
         afficher le lien (ou l'ouvrir dans un autre navigateur).`,
        CLIENT_SHAREABLE_LINK: `Ceci est un lien partageable du profil du client. Si tu veux
         voir ce qu'un candidat verra, assurez-vous de vous déconnecter, puis
         afficher le lien (ou l'ouvrir dans un autre navigateur).`,
        TYPE_YOUR_NAME_TO_SIGN: 'Veuillez taper votre nom (vous acceptez à ce titre que cela équivaut à une signature manuscrite)'
    },
    TABLE_HEADERS: {
        ACTIONS: "Actions",
        NOTES: "Remarques",
        VALUE: "Valeur"
    },
    OPTIONS: {
        YES: "Oui",
        NO: "Non",
    },
    ERROR_MESSAGES: {
        FIELD_REQUIRED: "Ce champ est requis."
    },
    APPLICATION_FORM: {
        WAIT_FOR_PROCESSING: "Traitement en cours, veuillez patienter...",
        STEP_OF: "Étape {0} de {1}"
    },
    REFERENCE_CHECK_FORM: {
        FILL_THE_FORM_REQUEST: "Veuillez nous aider à remplir le formulaire ci-dessous",
        REFERENCE_FOR: "Référence pour {0} {1}",
        REFERENCE_INPUT_BY: "Informations de référence saisies par {0} {1}",
        FORM_SUBMITTED: "Le formulaire de vérification des références a été soumis !"
    },
    FILE_UPLOAD: {
        UPLOAD_INSTRUCTION: "Déposez un fichier ici ou cliquez pour télécharger",
        MAXIMUM_UPLOAD_SIZE: "Taille d'importation maximale {0}MB",
        FILE_EXCEED_MAXIMUM: "La taille du fichier dépasse {0}MB.",
        FILE: "Ficher"
    },
    BOOKING_DIALOG: {
        LABEL: {
            START_TIME: "Heure de début",
            END_TIME: "Heure de fin",
            END_DATE: "Date de fin",
            SELECT_CLIENT: "Sélectionner un client",
            ASSIGNED_CANDIDATE: "Voulez-vous attribuer ce poste ?",
            REPEAT: "Voulez-vous ce service plus d'une fois (répétitive/récurrente) ?",
            REPEAT_UNTIL: "Répéter jusqu'à",
            REPEAT_EVERY: "Répéter chaque",
            REPEAT_ON: "Répéter activé",
            BOOKING_ADDRESS: "Adresse de réservation",
            ADDRESS_LINE2: "Ligne d'adresse 2",
            CITY: "Ville",
            STATE: "État/Province",
            ZIP_CODE: "Code postal",
            NUMBER_CHILDREN: "Combien d'enfants seront pris en charge ?",
            SELECT_JOB_CATEGORY: "Sélectionner la catégorie d'emploi",
            SELECT_DATE: "Date de réservation",
            SELECT_SERVICE: "Sélectionner le service"
        },
        OPTIONS: {
            REPEAT_TYPE: ["Jours", "Semaines"],
            REPEAT_ON: [
                "Lundi",
                "Mardi",
                "Mercredi",
                "Jeudi",
                "Vendredi",
                "Samedi",
                "Dimanche"
            ]
        }
    },
    MENU_BAR: {
        TOP: {
            MESSAGES: "Messages",
            SMS: "SMS",
            JOBS: "Tâches",
            LOGOUT: "Déconnexion",
            DASHBOARD: "Mon tableau de bord"
        },
        ADMIN: {
            USERS: {
                ROOT: "Utilisateurs",
                CLIENTS: "Client",
                CANDIDATES: "Candidats",
                ADMINISTRATORS: "Administrateurs"
            },
            JOBS_EVENTS: {
                ROOT: "Emplois et événements",
                SHIFT_JOB_CALENDAR: "Calendrier des tâches d'équipe",
                PLACEMENT_JOBS: "Emplois de placement",
                PERSONAL_TO_DO: "Personnel à faire"

            },
            TEMPLATES: {
                ROOT: "Modèles",
                EMAIL: "Modèles d'e-mail",
                DOCUMENT: "Modèles de documents",
                NOTE: "Modèles de notes",
                PROFILE: "Modèles de profil",
            },
            SETTINGS: {
                ROOT: "Paramètres",
                AGENCY: "Paramètre de l'agence",
                ADMIN: "Paramètre d'administration"
            },
            BUILDERS: {
                ROOT: "Constructeurs",
                PROFILE: "Constructeur de profil",
                EVALUATION: "Constructeur d'évaluation"
            },
            LOGS: {
                ROOT: "Journaux",
                COMMUNICATION_LOG: "Journal des communications",
                STATUS_CHANGES: "Changements de statut",
                ACTIVITY_LOG: "Journal d'activité"
            },
            OTHERS: {
                ROOT: "Autres",
                RESOURCE_MANAGER: "Gestionnaire de ressources",
                REFERENCES: "Références",
                DOCUMENTS: "Documents",
                EMAIL_BLASTER: "Email Blaster",
                NOTIFICATION_CENTER: "Centre de notifications",
                SNAPSHOT: "Instantané"
            }

        }
    },
    NAV_BAR: {
        TOP: "Haut",
        CHECKLIST: "Liste de contrôle",
        DOCUMENTS: "Documents",
        PHOTO_GALARY: "Galerie de photos",
        INTRODUCTION_VIDEO: "Vidéo de présentation"
    },
    ENGINEHOW: {
        PROFILE_BUILDER: {
            BASIC: "Bases du générateur de profils",
            REQUIRE_FIELD: "Comment marquer les questions/champs comme obligatoires ou non",
            NOTIFICATION_DESTINATION: "Modifier qui est informé des nouveaux candidats",
            EDIT_APPLICATION: `Comment modifier plus facilement les formulaires de candidature`,
            ADD_SECTION_QUESTION:"Comment ajouter une question à une section",
            ADD_CONFIRMATION_BOX: "Comment ajouter des champs de confirmation sur les formulaires de candidature"
        },
        EVALUATION_BUILDER: {
            GETTING_STARTED: "Commencer avec les évaluations"
        },
        EMAIL_TEMPLATES: {
            GETTING_STARTED: " Premiers pas avec les modèles d'e-mail ",
            DEFAULT_EMAIL_FOOTER: "Configuration de votre pied de page d'e-mail par défaut"
        },
        DOCUMENT_TEMPLATES: {
            GETTING_STARTED: "Démarrer avec les modèles de documents",
            NOTIFICATION_WHEN_SIGNED: "Ajouter une notification lorsque le document est signé",
            ADD_DOCUMENT: "Ajouter manuellement un document à un utilisateur"
        },
        AGENCY: {
            STATUSES_CHECKLISTS_TYPES: "Cartographier votre processus via des statuts, des listes de contrôle et des types",
            AGENCY_BRANDING_SETUP: "Configuration de la marque de l'agence (logo, couleurs, polices)",
            PROFILE_COMPLETE_SETUP: `Comment ajouter un bouton "Mon profil est complet" sur lequel les candidats peuvent cliquer pour vous informer qu'ils ont complété leur profil`,
            CONFIGURE_MULTIPLE_LOCATIONS: "Configurez votre agence pour desservir plusieurs emplacements distincts"
        },
        EMAIL_BLASTER: {
            HOW_TO: "Comment fonctionnent les envois d'e-mails ?"
        },
        CLIENTS:{
            SHARE_CANDIDATE_PROFILE: "Comment partager le profil d'un candidat avec un client"
        }
    },
    ADMIN_DASHBOARD: {
        WELCOME_HEADER: "Bienvenue dans {0} Mission Control",
        PRO_TIP: {
            HEADER: "Astuce de pro !",
            TEXT: "Apprenez à personnaliser les colonnes/informations que vous voyez dans les tableaux des candidats et des clients"
        },
        PLACE_HOLDERS: {
            ORDER_CLIENTS_BY: "Order les clients par",
            ORDER_CANDIDATES_BY: "Trier les candidats par"
        },
        BUTTONS: {
            ADD_CLIENT: "Ajouter un client",
            ADD_CANDIDATE: "Ajouter un candidat",
        },
    },
    ADD_USER_DIALOG: {
        HEADER: "Ajouter un nouvel utilisateur",
        DESCRIPTION: `Il s'agit d'un mécanisme permettant d'ajouter manuellement un utilisateur à votre base de données. Un utilisateur
        ajouté de cette manière sera mis dans le statut "Pre Application"
         (ce qui signifie qu'ils n'ont pas encore rempli de formulaire de demande). Un utilisateur dans
        ce statut peut toujours être envoyé pour compléter le formulaire de candidature. Si tu
        souhaite envoyer automatiquement un e-mail aux utilisateurs ajoutés de cette façon, vous
        peut ajouter un modèle d'e-mail qui est une "Notification de changement de statut"
        triggering lors d'un passage à "Pre Application".`,
        LABELS: {
            EMAIL: "E-mail",
            PHONE: "Numéro de téléphone",
            FIRST_NAME: "Prénom",
            LAST_NAME: "Nom de famille",
            PROFILE_BUILDER: "Constructeur de profil",
            USER_TYPES: "Types d'utilisateurs",
            LOCATIONS: "Lieux",
        }
    },
    STRIPE: {
        CONNECTED_SUCCESS: "Votre compte a été connecté avec succès à Stripe.",
        FAILED_TO_CONECT: "Un problème est survenu lors de la connexion de votre compte à Stripe, veuillez réessayer ou contacter Enginehire.",
        MISSING_INFO: "Votre compte a été connecté mais il manque des informations sur l'application Stripe, veuillez cliquer sur le bouton se connecter à Stripe pour continuer là où vous vous étiez arrêté",
    },
    DATA_TABLE: {
        SHOW: "Afficher",
        ITEMS_PER_PAGE: "éléments par page",
        SHOWING_RANGE: "Affichage de {0} à {1} entrées sur {2}"
    },
    EMPLOYER_DIALOG: {
        TABS: {
            ADMIN: "Administrateur",
            PROFILE: "Profil",
            INTAKE_NOTES: "Notes d'admission",
            COMMUNICATION_LOG: "Journal des communications",
            INTAKE_NOTES_MOBILE: "Notes",
            COMMUNICATION_LOG_MOBILE: "Com"
        },
        INTERVIEW_TABS: {
            PROFILE: "Profil",
            NOTES: "Remarques"
        },
        BUTTONS: {
            DELETE_CLIENT: "Supprimer le client"
        }
    },
    CANDIDATE_DIALOG: {
        TABS: {
            ADMIN: "Administrateur",
            PROFILE: "Profil",
            INTERVIEW: "Entretien",
            COMMUNICATION_LOG: "Journal des communications",
            RECORDS: "Enregistrements",
            COMMUNICATION_LOG_MOBILE: "Com"
        },
        INTERVIEW_TABS: {
            PROFILE: "Profil",
            INTERVIEW: "Entretien"
        },
        BUTTONS: {
            DELETE_CANDIDATE: "Supprimer le candidat"
        }
    },
    ADMIN_PANEL: {
        TYPES: {
            TITLE: "Types",
            BUTTON: "Enregistrer les types"
        },
        CHECKLIST: {
            TITLE: "Liste de contrôle",
            BUTTON: "Enregistrer la liste de contrôle"
        },
        TAGS: {
            TITLE: "Gestionnaire de balises",
            BUTTON: "Enregistrer les balises"
        },
        LOCATIONS: {
            TITLE: "Lieux",
            BUTTON: "Enregistrer les positions"
        },
        LANGUAGE: {
            TITLE: "Langue",
            BUTTON: "Enregistrer la langue"
        },
        SET_PROFILE_BUILDER: {
            TITLE: "Type de profil",
            BUTTON: "Mettre à jour le générateur de profil"
        },
        NOTES: {
            TITLE: "Remarques",
            DESCRIPTION: "Les notes prises ici sont réservées à l'usage interne de l'administrateur, elles ne sont pas visibles pour les utilisateurs.",
            BUTTON: "Ajouter une note"
        },
        EMAIL: {
            TITLE: "Envoyer un e-mail",
            BUTTON_SEND: "Envoyer",
            BUTTON_LOAD: "Charger",
            SELECT_TEMPLATE: "Sélectionner un modèle",
            FROM_EMAIL: "Depuis un e-mail"
        },
        SMS: {
            TITLE: "Envoyer des SMS",
            BUTTON: "Envoyer"
        },
        RESET_PASSWORD: {
            DESCRIPTION: "Vous pouvez réinitialiser manuellement le mot de passe de l'utilisateur ici",
            BUTTON: "Mettre à jour le mot de passe"
        },
        EVENT: {
            TITLE: "Planifier un événement (entretien, réunion, etc.)",
            DESCRIPTION: "Ces événements apparaîtront dans le tableau de bord de l'utilisateur.",
            EVENT_TITLE: "Titre de l'événement",
            EVENT_DATE: "Date de l'événement",
            EVENT_TIME: "Heure de l'événement",
            INTERVIEW_LINK: "Lien de l'entretien",
            INTERVIEW_LINK_PLACE_HOLDER: "Lien Zoom ou autre lien d'appel",
            NOTES: "Remarques",
            STATUS_UPDATE_TO: "Statut vers lequel mettre à jour l'utilisateur",
            SEND_EMAIL_NOTIFICATION: "Envoyer une notification par e-mail de l'événement en cours de planification",
            ADD_TO_CALENDAR: "Ajouter au calendrier personnel des tâches",
            BUTTON: "Planifier un événement"
        },
        CREDIT: {
            TITLE: "Crédits",
            BUTTON_ADD: "Ajouter un crédit",
            BUTTON_EDIT: "Modifier",
            EDIT_CREDIT_TITLE: "Modifier le crédit",
            PLACE_HOLDERS: {
                VALUE: "Valeur",
                NOTES: "Remarques"
            }
        },
        STRIPE: {
            BILL_CLIENT: "Vous pouvez facturer manuellement les clients via Stripe ici",
            SEND_INVOICE: "Vous pouvez envoyer manuellement des factures Stripe ici",
            BUTTON_CHARGE: "Charger via Stripe",
            BUTTON_RESET: "Réinitialiser les informations de bande",
            BUTTON_INVOICE: "Facture via Stripe",
            PAYMENT_LOGS: "Journaux de paiement"
        },
        REVIEW: {
            TITLE: "Commentaires",
            RATING: "Note",
            AVERAGE_RATING: "Note moyenne",
            NO_DATA: "Aucun avis pour le moment."
        },
        ADD_DOCUMENT: {
            TITLE: "Ajouter un document",
            DESCRIPTION: `Vous pouvez ajouter n'importe quel modèle de document à l'utilisateur à partir d'ici, sélectionnez-en un
            de vos documents dans le menu déroulant :`,
            BUTTON: "Ajouter un document",
        },
        RELATIONSHIP: {
            CANDIDATE: {
                TITLE: "Candidats désignés",
                NO_CANDIDATE: "Aucun candidat n'a été associé à ce client."
            },
            CLIENT: {
                TITLE: "Clients assignés",
                NO_CLIENT: "Aucun client n'a été lié à ce candidat."
            },
            ADD_CANDIDATE: "Ajouter un candidat"
        },
        LAST_CONTACTED_DATE: "Dernière contactée"
    },
    COMMUNICATION: {
        DATE: "Date",
        FROM: "De",
        TO: "À",
        SUBJECT: "Objet",
        MESSAGE: "Message",
        RE_SEND: "Renvoyer"
    },
    PLACEMENT_JOB: {
        SEARCH_TEXT: "Rechercher par intitulé de poste, ID de poste, horaire, ville, état ou description",
        JOB_HIDEN_DESCRIPTION: `Les offres d'emploi au statut "Brouillon", "Fermé" ou "Complété" n'apparaissent pas sur l'offre
        board par défaut. Pour mettre à jour le statut d'une tâche, cliquez sur "Modifier la tâche".`,
        CLIENT_POSTING_JOB_DESCRIPTION: "Ceci est pour publier des postes à plus long terme pour ce client.",
    },
    CONFIRM_DIALOGS: CONFIRM_DIALOGS,
    ERROR_DIALOGS: ERROR_DIALOGS,
    RESULT_DIALOGS: RESULT_DIALOGS
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/fr.js